module.exports = __webpack_public_path__ + "static/media/Preet_Trivedi.fcf1b2a5.jpg";